// @ts-check
import React, { useCallback } from 'react';
import { Formik } from 'formik';
import { FormStatusErrors } from 'preferral-ui/components/formik/FormStatusErrors';
import { Button } from 'preferral-ui/components/Button';
import { TextAreaField } from 'preferral-ui/components/formik/TextAreaField';

/** @typedef {{
  onSave(sections: any[]): void;
}} ImportQuestionnaireJSONFormProps */

/** @type { React.FC<ImportQuestionnaireJSONFormProps> } */
export const ImportQuestionnaireJSONForm = (props) => {
  const { onSave } = props;

  const onSubmit = useCallback(
    (values, formikActions) => {
      const { setStatus, setSubmitting } = formikActions;

      try {
        const sections = JSON.parse(values.json);
        return onSave(sections);
      } catch (e) {
        setStatus({
          errors: [{ key: '', message: (e && e.message) || JSON.stringify(e) }],
        });
        setSubmitting(false);
        return Promise.reject(e);
      }
    },
    [onSave]
  );

  return (
    <Formik initialValues={{ json: '' }} onSubmit={onSubmit}>
      {({ status, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <FormStatusErrors status={status} />

          <div className="mt-3">
            <TextAreaField
              label="Sections JSON"
              name="json"
              minRows={10}
              maxRows={30}
              className="form-input w-full font-mono text-xs text-green-300 bg-gray-700"
              placeholder="Paste JSON here..."
            />
          </div>
          <div className="mt-6 text-center">
            <Button
              type="submit"
              color="blue"
              kind="primary"
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Import Sections
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};
